import {
  GET_CATALOG_RECORDS,
  GET_CATALOG_SUCCESS,
  GET_CATALOG_ERROR,
  TOGGLE_CART_RECORDS,
  TOGGLE_CART_RECORD_SUCCESS,
  TOGGLE_CART_RECORD_ERROR,
  TOGGLE_REMOVE_CART_RECORDS,
  GET_CATALOG_SINGLE_RECORD,
  GET_CATALOG_SINGLE_SUCCESS,
  GET_CATALOG_SINGLE_ERROR,
  SHOW_CART_RECORDS,
} from "../actions";

const INIT_STATE = {
  searchResult: [],
  selectedFilters: {},
  vocabularyId: 0,
  loading: false,
  catalogListingLoading: false,
  error: "",
  toggleCartError: "",
  items: [],
  lineItemAdded: null,
  catalogItemSingle: null,
  showHideCartPanel: false,

  recordList: {
    records: [],
    searchText: "",
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null,
    orderId: null
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATALOG_SINGLE_RECORD:
      return { ...state, loading: true, catalogItemSingle: action.payload.catalogItemSingle };
    case GET_CATALOG_SINGLE_SUCCESS:
      return { ...state, loading: false, error: "", catalogItemSingle: action.payload };
    case GET_CATALOG_SINGLE_ERROR:
      return { ...state, loading: false, error: action.payload.message };
    case GET_CATALOG_RECORDS:
      return {
        ...state,
        loading: true,
        catalogListingLoading: true,
        error: "",
        recordList: null,
        searchText: action.payload.searchText,
        pageNumber: action.payload.pageNumber,
        termIds: action.payload.termIds,
        selectedFilters: action.payload.selectedFilters,
        vocabularyId: action.payload.vocabularyId
      };
    case GET_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        catalogListingLoading: false,
        error: "",
        recordList: action.payload,
      };
    case GET_CATALOG_ERROR:
      let recordList = { ...state.recordList, records: [] };
      recordList.pagination = {
        ...recordList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        catalogListingLoading: false,
        error: action.payload.message,
        recordList: recordList,
      };
    case TOGGLE_REMOVE_CART_RECORDS:
      let removeList = [];

      state.items.forEach((catalog) => {

        if (action.payload.catalogId == catalog.id) {
          catalog.qty = parseInt(catalog.qty) - 1;
        }

        if (catalog.qty > 0) {
          removeList.push(catalog);
        }
      });

      return { ...state, items: removeList };
    case SHOW_CART_RECORDS:
      return { ...state, showHideCartPanel: true };
    case TOGGLE_CART_RECORDS:
      return { ...state, loading: true, toggleCartError: "", catalogItemIdToAdd: action.payload.catalog ? action.payload.catalog.catalogItemId : null, lineItemAdded: null, showHideCartPanel: action.payload.showHideCartPanel };
    case TOGGLE_CART_RECORD_SUCCESS:
      return { ...state, loading: false, toggleCartError: "", catalogItemIdToAdd: null, lineItemAdded: action.payload.lineItemAdded, orderId: action.payload.orderId };
    case TOGGLE_CART_RECORD_ERROR:
      return { ...state, loading: false, toggleCartError: action.payload.message, catalogItemIdToAdd: null, lineItemAdded: null };
    default:
      return { ...state };
  }
};
